var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconMail(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { d: "M4.00009 6.46479V6H20.0001V6.46481L12.0001 11.7981L4.00009 6.46479ZM2.00009 6.98552C1.99997 6.99455 1.99997 7.00358 2.00009 7.01261V19C2.00009 19.5523 2.44781 20 3.00009 20H21.0001C21.5524 20 22.0001 19.5523 22.0001 19V7.01467C22.0003 7.00427 22.0003 6.99387 22.0001 6.98346V5C22.0001 4.44772 21.5524 4 21.0001 4H3.00009C2.44781 4 2.00009 4.44772 2.00009 5V6.98552ZM20.0001 8.86851V18H4.00009V8.86849L11.4454 13.832C11.7813 14.056 12.2189 14.056 12.5548 13.832L20.0001 8.86851Z", fill: color })));
}
//# sourceMappingURL=icon.mail.component.js.map